// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type InvoiceTermsFormMetadataQueryVariables = Types.Exact<{
  filter: Types.GlobalPlanMilestoneFilter;
}>;


export type InvoiceTermsFormMetadataQuery = { __typename?: 'Query', customers: Array<{ __typename?: 'Customer', id: string, name: string }>, regions: Array<{ __typename?: 'Region', id: string, name: string }>, globalPlanMilestones: { __typename?: 'GlobalPlanMilestonesPageResult', entities: Array<{ __typename?: 'GlobalPlanMilestone', id: string, name: string }> } };

export type InvoiceTermsFormQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type InvoiceTermsFormQuery = { __typename?: 'Query', invoiceScheduleTemplate: { __typename?: 'InvoiceScheduleTemplate', createdAt: Types.Scalars['DateTime']['input'], invoiceItemsIndependently: boolean, softCostDayOfMonth?: number | null | undefined, hardCostDayOfMonth?: number | null | undefined, id: string, name: string, softCostAmountType: { __typename?: 'InvoiceScheduleAmountTypeDetail', name: string, code: Types.InvoiceScheduleAmountType }, softCostTriggerType: { __typename?: 'InvoiceScheduleTriggerTypeDetail', name: string, code: Types.InvoiceScheduleTriggerType }, hardCostAmountType: { __typename?: 'InvoiceScheduleAmountTypeDetail', name: string, code: Types.InvoiceScheduleAmountType }, hardCostTriggerType: { __typename?: 'InvoiceScheduleTriggerTypeDetail', name: string, code: Types.InvoiceScheduleTriggerType }, lotType: { __typename?: 'LotTypeDetail', name: string, code: Types.LotType }, communityType?: { __typename?: 'CommunityTypeDetail', name: string, code: Types.CommunityType } | null | undefined, customer?: { __typename?: 'Customer', id: string } | null | undefined, regions: Array<{ __typename?: 'Region', id: string }>, items: Array<{ __typename?: 'InvoiceScheduleTemplateItem', id: string, iterations: number, amountInBasisPoints: number, invoiceDelayInDays: number, costClassificationType: { __typename?: 'CostClassificationTypeDetail', name: string, code: Types.CostClassificationType }, frequency: { __typename?: 'InvoiceScheduleItemFrequencyDetail', name: string, code: Types.InvoiceScheduleItemFrequency }, globalPlanMilestone: { __typename?: 'GlobalPlanMilestone', id: string } }> } };

export type SaveInvoiceTermsMutationVariables = Types.Exact<{
  input: Types.SaveInvoiceScheduleTemplateInput;
}>;


export type SaveInvoiceTermsMutation = { __typename?: 'Mutation', saveInvoiceScheduleTemplate: { __typename?: 'SaveInvoiceScheduleTemplateResult', invoiceScheduleTemplate: { __typename?: 'InvoiceScheduleTemplate', createdAt: Types.Scalars['DateTime']['input'], invoiceItemsIndependently: boolean, softCostDayOfMonth?: number | null | undefined, hardCostDayOfMonth?: number | null | undefined, id: string, name: string, softCostAmountType: { __typename?: 'InvoiceScheduleAmountTypeDetail', name: string, code: Types.InvoiceScheduleAmountType }, softCostTriggerType: { __typename?: 'InvoiceScheduleTriggerTypeDetail', name: string, code: Types.InvoiceScheduleTriggerType }, hardCostAmountType: { __typename?: 'InvoiceScheduleAmountTypeDetail', name: string, code: Types.InvoiceScheduleAmountType }, hardCostTriggerType: { __typename?: 'InvoiceScheduleTriggerTypeDetail', name: string, code: Types.InvoiceScheduleTriggerType }, lotType: { __typename?: 'LotTypeDetail', name: string, code: Types.LotType }, communityType?: { __typename?: 'CommunityTypeDetail', name: string, code: Types.CommunityType } | null | undefined, customer?: { __typename?: 'Customer', id: string } | null | undefined, regions: Array<{ __typename?: 'Region', id: string }>, items: Array<{ __typename?: 'InvoiceScheduleTemplateItem', id: string, iterations: number, amountInBasisPoints: number, invoiceDelayInDays: number, costClassificationType: { __typename?: 'CostClassificationTypeDetail', name: string, code: Types.CostClassificationType }, frequency: { __typename?: 'InvoiceScheduleItemFrequencyDetail', name: string, code: Types.InvoiceScheduleItemFrequency }, globalPlanMilestone: { __typename?: 'GlobalPlanMilestone', id: string } }> } } };

export type InvoiceTermsForm_InvoiceScheduleTemplateFragment = { __typename?: 'InvoiceScheduleTemplate', createdAt: Types.Scalars['DateTime']['input'], invoiceItemsIndependently: boolean, softCostDayOfMonth?: number | null | undefined, hardCostDayOfMonth?: number | null | undefined, id: string, name: string, softCostAmountType: { __typename?: 'InvoiceScheduleAmountTypeDetail', name: string, code: Types.InvoiceScheduleAmountType }, softCostTriggerType: { __typename?: 'InvoiceScheduleTriggerTypeDetail', name: string, code: Types.InvoiceScheduleTriggerType }, hardCostAmountType: { __typename?: 'InvoiceScheduleAmountTypeDetail', name: string, code: Types.InvoiceScheduleAmountType }, hardCostTriggerType: { __typename?: 'InvoiceScheduleTriggerTypeDetail', name: string, code: Types.InvoiceScheduleTriggerType }, lotType: { __typename?: 'LotTypeDetail', name: string, code: Types.LotType }, communityType?: { __typename?: 'CommunityTypeDetail', name: string, code: Types.CommunityType } | null | undefined, customer?: { __typename?: 'Customer', id: string } | null | undefined, regions: Array<{ __typename?: 'Region', id: string }>, items: Array<{ __typename?: 'InvoiceScheduleTemplateItem', id: string, iterations: number, amountInBasisPoints: number, invoiceDelayInDays: number, costClassificationType: { __typename?: 'CostClassificationTypeDetail', name: string, code: Types.CostClassificationType }, frequency: { __typename?: 'InvoiceScheduleItemFrequencyDetail', name: string, code: Types.InvoiceScheduleItemFrequency }, globalPlanMilestone: { __typename?: 'GlobalPlanMilestone', id: string } }> };

export const InvoiceTermsForm_InvoiceScheduleTemplateFragmentDoc = gql`
    fragment InvoiceTermsForm_InvoiceScheduleTemplate on InvoiceScheduleTemplate {
  ...Named
  createdAt
  invoiceItemsIndependently
  softCostDayOfMonth
  softCostAmountType {
    name
    code
  }
  softCostTriggerType {
    name
    code
  }
  hardCostDayOfMonth
  hardCostAmountType {
    name
    code
  }
  hardCostTriggerType {
    name
    code
  }
  lotType {
    name
    code
  }
  communityType {
    name
    code
  }
  customer {
    id
  }
  regions {
    id
  }
  items {
    id
    iterations
    amountInBasisPoints
    invoiceDelayInDays
    costClassificationType {
      name
      code
    }
    frequency {
      name
      code
    }
    globalPlanMilestone {
      id
    }
  }
}
    ${NamedFragmentDoc}`;
export const InvoiceTermsFormMetadataDocument = gql`
    query InvoiceTermsFormMetadata($filter: GlobalPlanMilestoneFilter!) {
  customers {
    ...Named
  }
  regions {
    ...Named
  }
  globalPlanMilestones(filter: $filter) {
    entities {
      ...Named
    }
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useInvoiceTermsFormMetadataQuery__
 *
 * To run a query within a React component, call `useInvoiceTermsFormMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTermsFormMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceTermsFormMetadataQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useInvoiceTermsFormMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InvoiceTermsFormMetadataQuery, InvoiceTermsFormMetadataQueryVariables> & ({ variables: InvoiceTermsFormMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvoiceTermsFormMetadataQuery, InvoiceTermsFormMetadataQueryVariables>(InvoiceTermsFormMetadataDocument, options);
      }
export function useInvoiceTermsFormMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvoiceTermsFormMetadataQuery, InvoiceTermsFormMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvoiceTermsFormMetadataQuery, InvoiceTermsFormMetadataQueryVariables>(InvoiceTermsFormMetadataDocument, options);
        }
// @ts-ignore
export function useInvoiceTermsFormMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InvoiceTermsFormMetadataQuery, InvoiceTermsFormMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InvoiceTermsFormMetadataQuery, InvoiceTermsFormMetadataQueryVariables>;
export function useInvoiceTermsFormMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvoiceTermsFormMetadataQuery, InvoiceTermsFormMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InvoiceTermsFormMetadataQuery | undefined, InvoiceTermsFormMetadataQueryVariables>;
export function useInvoiceTermsFormMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvoiceTermsFormMetadataQuery, InvoiceTermsFormMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InvoiceTermsFormMetadataQuery, InvoiceTermsFormMetadataQueryVariables>(InvoiceTermsFormMetadataDocument, options);
        }
export type InvoiceTermsFormMetadataQueryHookResult = ReturnType<typeof useInvoiceTermsFormMetadataQuery>;
export type InvoiceTermsFormMetadataLazyQueryHookResult = ReturnType<typeof useInvoiceTermsFormMetadataLazyQuery>;
export type InvoiceTermsFormMetadataSuspenseQueryHookResult = ReturnType<typeof useInvoiceTermsFormMetadataSuspenseQuery>;
export type InvoiceTermsFormMetadataQueryResult = ApolloReactCommon.QueryResult<InvoiceTermsFormMetadataQuery, InvoiceTermsFormMetadataQueryVariables>;
export const InvoiceTermsFormDocument = gql`
    query InvoiceTermsForm($id: ID!) {
  invoiceScheduleTemplate(id: $id) {
    ...InvoiceTermsForm_InvoiceScheduleTemplate
  }
}
    ${InvoiceTermsForm_InvoiceScheduleTemplateFragmentDoc}`;

/**
 * __useInvoiceTermsFormQuery__
 *
 * To run a query within a React component, call `useInvoiceTermsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceTermsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceTermsFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceTermsFormQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InvoiceTermsFormQuery, InvoiceTermsFormQueryVariables> & ({ variables: InvoiceTermsFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvoiceTermsFormQuery, InvoiceTermsFormQueryVariables>(InvoiceTermsFormDocument, options);
      }
export function useInvoiceTermsFormLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvoiceTermsFormQuery, InvoiceTermsFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvoiceTermsFormQuery, InvoiceTermsFormQueryVariables>(InvoiceTermsFormDocument, options);
        }
// @ts-ignore
export function useInvoiceTermsFormSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InvoiceTermsFormQuery, InvoiceTermsFormQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InvoiceTermsFormQuery, InvoiceTermsFormQueryVariables>;
export function useInvoiceTermsFormSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvoiceTermsFormQuery, InvoiceTermsFormQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InvoiceTermsFormQuery | undefined, InvoiceTermsFormQueryVariables>;
export function useInvoiceTermsFormSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvoiceTermsFormQuery, InvoiceTermsFormQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InvoiceTermsFormQuery, InvoiceTermsFormQueryVariables>(InvoiceTermsFormDocument, options);
        }
export type InvoiceTermsFormQueryHookResult = ReturnType<typeof useInvoiceTermsFormQuery>;
export type InvoiceTermsFormLazyQueryHookResult = ReturnType<typeof useInvoiceTermsFormLazyQuery>;
export type InvoiceTermsFormSuspenseQueryHookResult = ReturnType<typeof useInvoiceTermsFormSuspenseQuery>;
export type InvoiceTermsFormQueryResult = ApolloReactCommon.QueryResult<InvoiceTermsFormQuery, InvoiceTermsFormQueryVariables>;
export const SaveInvoiceTermsDocument = gql`
    mutation SaveInvoiceTerms($input: SaveInvoiceScheduleTemplateInput!) {
  saveInvoiceScheduleTemplate(input: $input) {
    invoiceScheduleTemplate {
      ...InvoiceTermsForm_InvoiceScheduleTemplate
    }
  }
}
    ${InvoiceTermsForm_InvoiceScheduleTemplateFragmentDoc}`;

/**
 * __useSaveInvoiceTermsMutation__
 *
 * To run a mutation, you first call `useSaveInvoiceTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveInvoiceTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveInvoiceTermsMutation, { data, loading, error }] = useSaveInvoiceTermsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveInvoiceTermsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveInvoiceTermsMutation, SaveInvoiceTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveInvoiceTermsMutation, SaveInvoiceTermsMutationVariables>(SaveInvoiceTermsDocument, options);
      }
export type SaveInvoiceTermsMutationHookResult = ReturnType<typeof useSaveInvoiceTermsMutation>;
export type SaveInvoiceTermsMutationResult = ApolloReactCommon.MutationResult<SaveInvoiceTermsMutation>;